import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@supoui/core/services/http.service';
import { ITimeZoneData } from '@supoui/shared/model/time-zone-data';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private httpService: HttpService) {}

  public requestTimeZoneId(latitude: number, longitude: number): Observable<ITimeZoneData> {
    return this.httpService.get<ITimeZoneData>(`services/supo-ui/api/timezone/timezoneid?latitude=${latitude}&longitude=${longitude}`);
  }
}
